//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    components: {},
    props: {
        tableData: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
};
